module.exports = __webpack_public_path__ + "img/yougansu.93cb7d2c.png";